import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatChipListbox, MatChipOption} from "@angular/material/chips";
import {CommonModule, NgForOf} from "@angular/common";
import {ClientRelationResponse} from "./model/client-relation-response";
import {Subject, takeUntil} from "rxjs";
import {ClientRelationService} from "./service/client-relation.service";

@Component({
    selector: 'app-client-relation',
    standalone: true,
    imports: [
        MatChipListbox,
        MatChipOption,
        NgForOf,
        CommonModule
    ],
    templateUrl: './client-relation.component.html'
})
export class ClientRelationComponent implements OnInit, OnDestroy {
    clientRelations: ClientRelationResponse;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    @ViewChild('clientRelationsChipList')
    clientRelationsChipList: MatChipListbox;

    constructor(
        private clientRelationService: ClientRelationService
    ) {
    }

    ngOnInit(): void {
        this.clientRelationService
            .getRelations()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((clientRelations: ClientRelationResponse) => {
                this.clientRelations = clientRelations;
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    updateRelations($event) {
        if (this.clientRelationService.getClientIds(this.clientRelations).length === 1 && !$event.source.selected) {
            $event.source.selected = true;
        } else {
            this.clientRelations.relatedClients.find(
                relation => relation.id === $event.source.value
            ).enabled = $event.source.selected;

            this.clientRelationService.updateRelations(this.clientRelations);
        }
    }

    updateMainClientStatus($event) {
        if (this.clientRelationService.getClientIds(this.clientRelations).length === 1 && !$event.source.selected) {
            $event.source.selected = true;
        } else {
            this.clientRelations.client.enabled = $event.source.selected;
            this.clientRelationService.updateRelations(this.clientRelations);
        }
    }
}
